import React from 'react'
import MiniDrawer from '../layout/MiniDrawer'
import DefaultLayout from "../layout/index.js"
import "../shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "../App.css";


import "../assets/styling/Styles.css"
function App() {
  return (
    <div>
    <DefaultLayout/>
    </div>
  )
}

export default App